"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initializeAndConnect = void 0;
/* eslint-disable import/prefer-default-export */
var doesCurrentStoreHasExtraStores = function doesCurrentStoreHasExtraStores(stores, objectStoreNames) {
  return Object.values(objectStoreNames).some(function (store) {
    return !stores.includes(store);
  });
};
var _initializeAndConnect = exports.initializeAndConnect = function initializeAndConnect() {
  var objectStores = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return new Promise(function (resolve, reject) {
    var db = null;
    var DBOpenRequest = null;
    if (!version) DBOpenRequest = indexedDB.open('xto10x-cache');else DBOpenRequest = indexedDB.open('xto10x-cache', version);
    DBOpenRequest.onsuccess = function (e) {
      db = e.target.result;
      if (objectStores.some(function (store) {
        return !db.objectStoreNames.contains(store);
      }) || doesCurrentStoreHasExtraStores(objectStores, db.objectStoreNames)) {
        db.close();
        return resolve(_initializeAndConnect(objectStores, db.version + 1));
      }
      resolve(db);
    };
    DBOpenRequest.onupgradeneeded = function (e) {
      db = e.target.result;
      objectStores.filter(function (store) {
        return !db.objectStoreNames.contains(store);
      }).forEach(function (store) {
        return db.createObjectStore(store);
      });
      Object.values(db.objectStoreNames).filter(function (store) {
        return !objectStores.includes(store);
      }).forEach(function (store) {
        return db.deleteObjectStore(store);
      });
      resolve(db);
    };
    DBOpenRequest.onerror = function (e) {
      reject(e);
    };
  });
};